import useEntity from "../../hooks/useContractor";
import ContractorDetail from "../../components/contractor/ContractorDetail/ContractorDetail";
import ContractorScoped from "../../components/contractor/ContractorDetail/ContractorScoped";
import ContractorTabs from "../../components/contractor/ContractorDetail/ContractorTabs";
import { useGetContractorQuery } from "../../apis/Contractor.api";
import { PrimaryContractor } from "../../types/models/Contractor";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorDetailPage = () => {

    useTitle(t`Details Contractor`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { contractorId: id } = useParams();

    const { data, refetch } = useGetContractorQuery(PrimaryContractor.fromPath(id))
    const { deleteContractor } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteContractor(data, '..')
    }, [data, deleteContractor])

    if (id === 'scoped') {
        return (<ContractorScoped/>)
    }

    return (
        <Box data-testid="Contractor-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ContractorDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Contractors/update/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/Contractors/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="Contractor-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Contractors/delete/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/Contractors/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="Contractor-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ContractorTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ContractorDetailPage;
